import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

/**
 * Host único de `<p-toast>` y `<p-confirmDialog>`.
 *
 * Ambos son componentes de UNA sola instancia por app: se suscriben al Subject
 * de `MessageService` / `ConfirmationService`, que es multicast, así que dos
 * `<p-confirmDialog>` montados a la vez abren DOS modales por cada `confirm()`.
 * Por eso ninguna feature declara el suyo; todas usan estos.
 *
 * Los servicios NO se proveen acá a propósito: van en `app.config.ts` (root).
 * Proveerlos también en este componente creaba una segunda instancia para el
 * árbol de rutas, distinta de la que inyectan los interceptors y el
 * `GlobalErrorHandler` (que son root) — sus toasts salían por una instancia que
 * este `<p-toast>` no escuchaba y no se veían nunca.
 */
@Component({
  selector: 'fga-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  template: `
    <p-toast position="top-right" />
    <p-confirmDialog />
    <router-outlet />
  `,
})
export class AppComponent {}
